// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","content":"Card_content__ASKh8","img":"Card_img__E1+8x","badge":"Card_badge__8Aen9"};